export const documentRoot = (element) =>   {
  const rootNode = element?.getRootNode()
  return rootNode?.body || rootNode
}
